import Service from "../../AuthService";

const Transactions = {
    getTransactionTypes() {
        return Service.get("/transaction-types")
    }
}

export default Transactions
